import { render } from "./WCSideBarV2.vue?vue&type=template&id=7b0f1a5a&scoped=true"
import script from "./WCSideBarV2.vue?vue&type=script&lang=js"
export * from "./WCSideBarV2.vue?vue&type=script&lang=js"

import "./WCSideBarV2.vue?vue&type=style&index=0&id=7b0f1a5a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b0f1a5a"]])

export default __exports__